import { Injectable, inject } from '@angular/core';
import { environment } from '../environment';

@Injectable({ providedIn: 'root' })
export class SharedDataService {
  private env = inject(environment);
  private cookieName = `SharedData${this.env.name}`;

  public getSharedData(name: string): string {
    const cookie = this.getSharedCookie();
    if (cookie) {
      const value = JSON.parse(cookie);
      return Object.prototype.hasOwnProperty.call(value, name)
        ? value[name]
        : undefined;
    }
  }

  public setSharedData(name: string, value: string) {
    const currentCookieValue = this.getSharedCookie();
    const cookieValue = currentCookieValue
      ? JSON.parse(currentCookieValue)
      : {};
    cookieValue[name] = value;

    let cookie =
      `${this.cookieName}=` +
      `${encodeURIComponent(JSON.stringify(cookieValue))};` +
      `path=/`;
    // ;secure`;
    if (this.env.cookieDomain !== 'localhost') {
      cookie += `;domain=${this.env.cookieDomain};`;
    }

    document.cookie = cookie;
  }

  private getSharedCookie() {
    const nameLenPlus = this.cookieName.length + 1;
    return (
      document.cookie
        .split(';')
        .map((c) => c.trim())
        .filter((cookie) => {
          return (
            cookie.slice(0, Math.max(0, nameLenPlus)) === `${this.cookieName}=`
          );
        })
        .map((cookie) => {
          return decodeURIComponent(cookie.slice(Math.max(0, nameLenPlus)));
        })[0] || undefined
    );
  }
}
